<template>
  <TableSet :tableSet="tableSet" />
</template>

<script lang="ts" setup>
import { computed } from 'vue';
import { useQuery } from '@vue/apollo-composable';
import TableSetQueryGraphQL from './TableSet.query.graphql';
import TableSet from '@/components/TableSet/TableSet.vue';

const props = defineProps<{
  tableSetId: string;
}>();

const { result: queryResult } = useQuery(TableSetQueryGraphQL, {
  path: props.tableSetId,
});

const tableSet = computed(() => {
  return {
    rows: queryResult.value?.item?.children?.map((row: any) => {
      return {
        title: row.title,
        cols: row.children?.map((col: any) => {
          return {
            text: col.text,
          };
        }),
      };
    }),
  };
});
</script>
